import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BaseRendererComponent} from "../base-renderer/base-renderer.component";
import {MagicRendererProperties} from "../../../models/properties/magic-renderer-properties.enum";
import {ChangeArgs, RadioButtonComponent} from "@syncfusion/ej2-angular-buttons";
import {ViewMode} from "../../../models/type/view-mode.enum";

/**
 * NOTE: the ejs-radiobutton instances ought to share a name so they display radio behaviour
 * but if I do that they no longer get initially checked (perhaps a bug). We use the change event instead.
 */
@Component({
  selector: 'sb-switch-renderer',
  templateUrl: './switch-renderer.component.html',
  styleUrls: ['./switch-renderer.component.scss']
})
export class SwitchRendererComponent extends BaseRendererComponent implements OnInit, AfterViewInit {

  @ViewChild("radioTrue", {static: false})
  radioTrue: RadioButtonComponent;

  @ViewChild("radioFalse", {static: false})
  radioFalse: RadioButtonComponent;

  constructor(private hostElement: ElementRef<HTMLElement>) {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  labelTrue() {
    return this.rendererProperties()[MagicRendererProperties.LABEL_TRUE] || "common.switch.true";
  }

  labelFalse() {
    return this.rendererProperties()[MagicRendererProperties.LABEL_FALSE] || "common.switch.false";
  }

  checked() {
    return this.fieldValue() === true;
  }

  disabled() {
    return this.elementOrViewModeReadOnly();
  }

  change(e: ChangeArgs) {
    if (e.value === "true") {
      this.radioFalse.checked = false;
    } else {
      this.radioTrue.checked = false;
    }
  }
}
